import { useContext } from 'react';
import { Bullets, ModalContext, Modals, Text } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import { useTranslation } from 'Hooks/useTranslation';
import * as Styled from './styles';

const YearsModal = (): JSX.Element => {
  const { t } = useTranslation(locizeNS.FILING);
  const { hideModal } = useContext(ModalContext);

  return (
    <Modals.Centered
      maxSize="S"
      hasClose={false}
      onClose={hideModal}
      buttonsAlign="center"
      primaryButton={{
        label: t('YearsModal.button'),
        onClick: () => {
          hideModal();
        },
      }}
    >
      <Styled.ModalContainer
        direction="column"
        align="center"
        justify="center"
        fullWidth
        gap="dimension_08"
      >
        <Text align="center" type="paragraphs" size="M_L_S" color="dark">
          {t('YearsModal.subtitle')}
        </Text>
        <Bullets
          bullets={[
            {
              text: t('YearsModal.info.first'),
            },
            {
              text: t('YearsModal.info.second'),
            },
          ]}
          icon={{
            height: 16,
            type: 'IconTickCleanSGreen',
            width: 16,
          }}
          spacing="M"
        />
      </Styled.ModalContainer>
    </Modals.Centered>
  );
};

export default YearsModal;
